import type { TaskStatus } from '../types/domain'

export const TASK_STATUSES: TaskStatus[] = ['pendiente', 'en-progreso', 'bloqueada', 'completada']

export const TASK_STATUS_LABEL: Record<string, string> = {
  pendiente: 'Pendiente',
  'en-progreso': 'En progreso',
  bloqueada: 'Bloqueada',
  completada: 'Completada',
}

interface StatusColor {
  dot: string
  text: string
  chipBg: string
  chipText: string
}

/**
 * Paleta unica de colores por estado de tarea. Se usa igual en el calendario,
 * el kanban y su leyenda, para que el mismo color signifique lo mismo en
 * toda la app (pendiente=azul, en-progreso=naranja, bloqueada=rojo,
 * completada=verde).
 */
const TASK_STATUS_COLOR: Record<string, StatusColor> = {
  pendiente: { dot: 'bg-accent', text: 'text-accent', chipBg: 'bg-accent/15', chipText: 'text-accent' },
  'en-progreso': { dot: 'bg-orange', text: 'text-orange', chipBg: 'bg-orange/15', chipText: 'text-orange' },
  bloqueada: { dot: 'bg-danger', text: 'text-danger', chipBg: 'bg-danger/15', chipText: 'text-danger' },
  completada: { dot: 'bg-green', text: 'text-green', chipBg: 'bg-green/15', chipText: 'text-green' },
}

export function taskStatusColor(status: string): StatusColor {
  return TASK_STATUS_COLOR[status] ?? TASK_STATUS_COLOR.pendiente
}
